export default __webpack_public_path__ + "static/The Home_Image 4_carousel 4@2x-c45016e4c11f945097709a8f2113587e.jpg";